import React from 'react';
import { DetailsCard, DetailsCardFooter, Flex, Grid } from '@tq/ui-components';

import { RelatedApplicationResponse } from 'types';
import { ApplicationCardBody } from '../../ApplicationCard/ApplicationCardBody';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { renderCardLabelledValue } from 'components';
import { useTranslation } from 'react-i18next';
import { RelatedApplicationCardHeader } from './RelatedApplicationCardHeader';
import { useFormatLocaleDate } from 'config/DateFormats/useFormatLocaleDate';

export type RelatedApplicationCardProps = {
  relatedCase: RelatedApplicationResponse;
  textExpanded?: boolean;
};

export const RelatedApplicationCard: React.FC<RelatedApplicationCardProps> = ({
  relatedCase,
}) => {
  const { t } = useTranslation('case_details_related');
  const formatLocaleDate = useFormatLocaleDate();

  return (
    <DetailsCard data-testid='case-detail-card'>
      <RelatedApplicationCardHeader relatedCase={relatedCase} />
      <ApplicationCardBody
        relatedCase={relatedCase}
        textExpanded={true}
        toggleClick={() => {}}
        showExpanded={false}
      />
      <DetailsCardFooter
        backgroundColor={COLOURS.gray[200]}
        py={3}
        data-testid='case-detail-card-footer'
        fontSize='sm'
      >
        <Grid
          gridAutoFlow={{ base: 'row', lg: 'column' }}
          gridGap={2}
          justifyContent='space-between'
        >
          <Flex alignItems='start'>
            {renderCardLabelledValue(
              t('application_reference', 'Application reference'),
              relatedCase.relatedApplicationReferenceNumber ?? '-'
            )}
          </Flex>
          <Flex alignItems={{ base: 'start', lg: 'end' }}>
            {renderCardLabelledValue(
              t('received', 'Received'),
              formatLocaleDate(relatedCase.dateReceived)
            )}
          </Flex>
        </Grid>
      </DetailsCardFooter>
    </DetailsCard>
  );
};
